import styled from 'styled-components';
import * as style from '../DTUpdateTicketFieldNode/DTUpdateTicketFieldNode.styles';
export const Container = styled(style.Container)``;
export const InnerContainer = styled(style.InnerContainer)`
  max-width: 380px;
`;
export const SubText = styled(style.SubText)``;

export const SubmitButton = styled(style.SubmitButton)`
  width: 150px;
  padding: 5px 20px;
  margin-left: 13px;
`;
